import { Map, useMapClickOwner } from 'components/map';
import { getMapDefaultConfig } from 'components/map/atoms';
import {
  CrossSectionMapDrawer,
  CrossSectionMapTool,
  CrossSectionRail,
  CrossSectionSettingsPanel,
  crossSectionArmedAtom,
} from 'components/cross-section';
import { useAtomValue } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import style from './page.module.scss';

const mapConfigAtom = atomWithStorage(
  'insights-summary-map-config',
  getMapDefaultConfig({
    developmentAreas: {
      checked: true,
      options: {
        horizontalUnits: true,
        verticalUnits: false,
        fieldUnits: false,
        pricing: false,
      },
    },
    scrollZoom: {
      checked: true,
    },
  })
);

const DevelopmentAreaSummaryMapPage = () => {
  const latitude = 31.72;
  const longitude = -102.26;
  // A drawn section takes map clicks while armed, so pins leave them alone.
  useMapClickOwner('cross-section', useAtomValue(crossSectionArmedAtom));
  return (
    <div className={style.wrapper}>
      {/* Beside the map rather than over it: the rail is where the section's display
          is configured, and it has to be readable at the same time as the plot. */}
      <CrossSectionRail />
      <div className={style.stage}>
        <Map
          latitude={latitude}
          longitude={longitude}
          className={style.map}
          zoom={13}
          showControls
          showMapFilters
          mapConfigAtom={mapConfigAtom}
          isLandingPageMap
        >
          {/* Offers the Cross-Section tool on this map: the arm button joins the
            control stack, and the drawn section renders here. */}
          <CrossSectionMapTool />
        </Map>
        {/* This page is all map, so the drawer sits over the foot of it rather than
            taking a region of its own, and the settings panel comes in from the
            right over both. */}
        <CrossSectionMapDrawer />
        <CrossSectionSettingsPanel />
      </div>
    </div>
  );
};

export { DevelopmentAreaSummaryMapPage };
